import React from "react"
import {MainCP} from "../../Components/areas-prioritarias-gobierno/MainCP"

const ViewAreasPrioritariasGobierno: React.FC = () => <MainCP/>

export default ViewAreasPrioritariasGobierno;